/**
 * Check if input is an object
 * @returns {Boolean}
 */
export const isAnObject = (input) => {
  return (
    input !== null && 
    typeof input === 'object' && 
    !Array.isArray(input)
  );
}
